<abp-modal-header
  [title]="
    options
      ? ('ChangeLogs' | localize) +
        ':' +
        (options.entityTypeFullName | localize) +
        '(' +
        options.entityTypeDescription +
        ')'
      : ''
  "
  (onCloseClick)="close()"
>
</abp-modal-header>
<div class="modal-body p-0">
  <div class="table-responsive">
    <table class="table table-striped table-bordered" [busy]="isTableLoading">
      <thead class="bg-light">
        <tr>
          <th style="width: 15%">
            {{ "Select" | localize }}
          </th>
          <th>
            {{ "Action" | localize }}
          </th>
          <th>
            {{ "UserName" | localize }}
          </th>
          <th>
            {{ "Time" | localize }}
          </th>
          <th>{{ "Actions" | localize }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let record of entities
              | paginate
                : {
                    id: 'server',
                    itemsPerPage: pageSize,
                    currentPage: pageNumber,
                    totalItems: totalItems
                  }
          "
        >
          <td>
            <button
              class="btn btn-icon btn-sm btn-secondary"
              (click)="showEntityChangeDetails(record)"
              title="{{ 'Select' | localize }}"
            >
              <i class="fa fa-search" [attr.aria-label]="l('Select')"></i>
            </button>
          </td>
          <td>
            <span class="p-column-title">{{ "Action" | localize }}</span>
            {{ record.changeTypeName }}
          </td>
          <td>
            <span class="p-column-title">{{ "UserName" | localize }}</span>
            {{ record.userName }}
          </td>
          <td>
            <span class="p-column-title">{{ "Time" | localize }}</span>
            {{ record.changeTime | momentPipe : "YYYY-MM-DD hh:mm:ss" }}
          </td>
          <!-- <td>
          <button
            type="button"
            class="btn btn-icon btn-sm btn-secondary"
            (click)="showAuditLogDetails(record)"
          >
            <i
              class="fa fa-search"
              [attr.aria-label]="'Search' | localize"
            ></i>
          </button>
        </td> -->
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row">
    <div class="col-sm-4 col-12 text-sm-left">
      <button class="btn btn-secondary" (click)="refresh()">
        <i class="fas fa-redo-alt"></i>
      </button>
    </div>
    <div class="col-sm-4 col-12 text-center">
      <p class="mb-0 my-2">
        {{ "TotalRecordsCount" | localize }}: {{ totalItems }}
      </p>
    </div>
    <div class="col-sm-4 col-12">
      <div class="float-sm-right m-auto">
        <abp-pagination-controls id="server" (pageChange)="getDataPage($event)">
        </abp-pagination-controls>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light-primary fw-bold" (click)="close()">
    {{ "Close" | localize }}
  </button>
</div>
